// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__kgDju","inner":"Footer_inner__1ZVfg","nextIcon":"Footer_nextIcon__1wc2e","innerLeft":"Footer_innerLeft__3bfEp"};